// extracted by mini-css-extract-plugin
export default {"searchStop":"searchStop_searchStop__qp03v","found":"searchStop_found__mAhHm"};